import { get, writable, derived, readable } from "svelte/store";
import { calculatorData } from "./planData.js";
import deepCopy from "../utils/deepCopy.js";
import formatDollars from "../utils/formatDollars.js";
// import rawCopy from "../../public/df_assets/copy/copy.csv";
import { rawCopy } from "./rawData.js";

// const allPlanData = get(calculatorData);
export const allPlanData = derived([calculatorData], ([$calculatorData]) => {
  if (!$calculatorData) return null;
  return $calculatorData;
});

//will it be a problem to have current plan data and assume years of service
export const dropdownData = derived([allPlanData], ([$allPlanData]) => {
  if (!$allPlanData) return null;

  const planData = $allPlanData.filter((row) => {
    return row.YOS === 0;
  });

  return planData;
});

//DROPDOWNS
export const currentPlanId = writable(1010102);
export const currentScenario = writable(1);

//USER INPUTS
export const currentAge = writable(null);
export const currentYearsOfService = writable(null);
export const currentFinalAverageSalaryFormatted = writable(null);

export const currentFinalAverageSalary = derived(
  [currentFinalAverageSalaryFormatted],
  ([$currentFinalAverageSalaryFormatted]) => {
    return $currentFinalAverageSalaryFormatted
      ? +$currentFinalAverageSalaryFormatted.replace(/[\D\s\._\-]+/g, "")
      : null;
  }
);

export const ageAtRetirement = writable(null);

//will it be a problem to have current plan data and assume years of service
export const generalPlanData = derived(
  [allPlanData, currentPlanId],
  ([$allPlanData, $currentPlanId]) => {
    if ($allPlanData && $currentPlanId) {
      const planData = $allPlanData.find((row) => {
        return row.equableclassid === $currentPlanId && row.YOS === 0;
      });

      return planData;
    }
    return null;
  }
);

export const totalEstimatedYearsOfService = derived(
  [
    currentScenario,
    generalPlanData,
    currentAge,
    currentYearsOfService,
    ageAtRetirement,
  ],
  ([
    $currentScenario,
    $generalPlanData,
    $currentAge,
    $currentYearsOfService,
    $ageAtRetirement,
  ]) => {
    if ($currentScenario === 1) {
      if ($generalPlanData && $currentAge && $currentYearsOfService) {
        return (
          $generalPlanData["normal_retirement_age"] -
          $currentAge +
          $currentYearsOfService
        );
      }
      return null;
    }

    if ($currentScenario === 2) {
      if ($currentYearsOfService) {
        return $currentYearsOfService;
      }
      return null;
    }

    if ($currentScenario === 3) {
      if ($currentYearsOfService) {
        return $currentYearsOfService + 1;
      }
      return null;
    }

    if ($currentScenario === 5) {
      if ($currentAge && $currentYearsOfService && $ageAtRetirement) {
        return (
          $generalPlanData["normal_retirement_age"] +
          $ageAtRetirement -
          $currentAge +
          $currentYearsOfService
        );
      }
      return null;
    }

    return null;
  }
);

export const currentYOSPlanData = derived(
  [allPlanData, currentPlanId, currentYearsOfService],
  ([$allPlanData, $currentPlanId, $currentYearsOfService]) => {
    if ($currentPlanId && $currentYearsOfService) {
      const planData = $allPlanData.find((row) => {
        return (
          row.equableclassid === $currentPlanId &&
          row.YOS === $currentYearsOfService
        );
      });

      return planData;
    }
    return null;
  }
);

export const adjustedYOSPlanData = derived(
  [allPlanData, currentScenario, currentPlanId, totalEstimatedYearsOfService],
  ([
    $allPlanData,
    $currentScenario,
    $currentPlanId,
    $totalEstimatedYearsOfService,
  ]) => {
    if ($currentScenario && $currentPlanId) {
      if ($totalEstimatedYearsOfService) {
        let cappedYearsOfService =
          $totalEstimatedYearsOfService > 65
            ? 65
            : $totalEstimatedYearsOfService;

        const planData = $allPlanData.find((row) => {
          return (
            row.equableclassid === $currentPlanId &&
            row.YOS === cappedYearsOfService
          );
        });

        return planData;
      }

      return null;
    }
    return null;
  }
);

//HIDDEN CALCULATED FIELDS
// export const additionalYearsToWork = derived(
//   [currentScenario, currentPlanData, currentAge, ageAtRetirement],
//   ([$currentScenario, $currentPlanData, $currentAge, $ageAtRetirement]) => {
//     if ($currentPlanData && $currentAge && $currentScenario) {
//       if ($currentScenario === 1) {
//         return $currentPlanData["normal_retirement_age"] - $currentAge;
//       } else if ($currentScenario === 5 && $ageAtRetirement) {
//         return $ageAtRetirement - $currentAge;
//       }
//       return null;
//     }
//     return null;
//   }
// );

//OUTPUTS
export const replacementRate = derived(
  [generalPlanData, adjustedYOSPlanData],
  ([$generalPlanData, $adjustedYOSPlanData]) => {
    if ($generalPlanData && $adjustedYOSPlanData) {
      let rate = $adjustedYOSPlanData["calculated_replacement_rate"];
      let maxRate = $generalPlanData["pension_max_replacement"];
      return Math.min(rate, maxRate);
    }
    return null;
  }
);

// export const replacementRate = derived(
//   [
//     currentScenario,
//     currentPlanData,
//     totalEstimatedYearsOfService,
//     currentYearsOfService,
//   ],
//   ([
//     $currentScenario,
//     $currentPlanData,
//     $totalEstimatedYearsOfService,
//     $currentYearsOfService,
//   ]) => {
//     if ($currentScenario === 1) {
//       if ($currentPlanData && $totalEstimatedYearsOfService) {
//         let rate =
//           $currentPlanData["multiplier"] * $totalEstimatedYearsOfService;
//         let maxRate = $currentPlanData["pension_max_replacement"];

//         return Math.min(rate, maxRate);
//       }
//       return null;
//     }

//     if ($currentScenario === 2) {
//       if ($currentPlanData && $currentYearsOfService) {
//         return $currentPlanData["multiplier"] * $currentYearsOfService;
//       }
//       return null;
//     }

//     if ($currentScenario === 3) {
//       if ($currentPlanData && $currentYearsOfService) {
//         return $currentPlanData["multiplier"] * ($currentYearsOfService + 1);
//       }
//       return null;
//     }

//     if ($currentScenario === 5) {
//       if ($currentPlanData && $totalEstimatedYearsOfService) {
//         let rate =
//           $currentPlanData["multiplier"] * $totalEstimatedYearsOfService;
//         let maxRate = $currentPlanData["pension_max_replacement"];

//         return Math.min(rate, maxRate);
//       }
//       return null;
//     }
//     return null;
//   }
// );

export const estimatedPension = derived(
  [replacementRate, currentFinalAverageSalary],
  ([$replacementRate, $currentFinalAverageSalary]) => {
    if ($replacementRate && $currentFinalAverageSalary) {
      return $replacementRate * $currentFinalAverageSalary;
    }
    return null;
  }
);

export const inflationAdjustedPension = derived(
  [
    currentScenario,
    generalPlanData,
    currentYOSPlanData,
    currentAge,
    estimatedPension,
  ],
  ([
    $currentScenario,
    $generalPlanData,
    $currentYOSPlanData,
    $currentAge,
    $estimatedPension,
  ]) => {
    if (
      $currentScenario &&
      $generalPlanData &&
      $currentYOSPlanData &&
      $currentAge &&
      $estimatedPension
    ) {
      if ($currentScenario === 1 || $currentScenario === 5) {
        return (
          $estimatedPension *
          Math.pow(
            1 - $currentYOSPlanData["inflation"],
            $generalPlanData["normal_retirement_age"] - $currentAge
          )
        );
      } else if ($currentScenario === 2 || $currentScenario === 3) {
        return (
          $estimatedPension /
          Math.pow(
            1 - $currentYOSPlanData["inflation"],
            $currentAge - $generalPlanData["normal_retirement_age"]
          )
        );
      }
      return null;
    }
    return null;
  }
);

//FLAGS
export const noCalcFlag = derived([generalPlanData], ([$generalPlanData]) => {
  if (
    $generalPlanData &&
    ($generalPlanData["plantype"] === "Guaranteed Return Plan" ||
      $generalPlanData["plantype"] === "Defined Contribution Plan")
  ) {
    return $generalPlanData["notes"] === 1
      ? $generalPlanData["notes_text"]
      : false;
  }
  return false;
});

export const hybridFlag = derived([generalPlanData], ([$generalPlanData]) => {
  if ($generalPlanData && $generalPlanData["plantype"] === "Hybrid Plan") {
    return $generalPlanData["notes"] === 1
      ? $generalPlanData["notes_text"]
      : false;
  }
  return false;
});

export const ssaFlag = derived(currentScenario, ($currentScenario) => {
  if ($currentScenario) {
    return false;
  }
  return false;
});

// export const vestingFlag = derived(
//   [currentScenario, currentPlanData, currentYearsOfService],
//   ([$currentScenario, $currentPlanData, $currentYearsOfService]) => {
//     if (
//       ($currentScenario === 2 || $currentScenario === 3) &&
//       $currentPlanData &&
//       $currentYearsOfService
//     ) {
//       return $currentPlanData["Vesting"] - $currentYearsOfService < 0;
//     }
//     return false;
//   }
// );

//TO_DO
export const vestingFlag = derived(
  [adjustedYOSPlanData],
  ([$adjustedYOSPlanData]) => {
    if ($adjustedYOSPlanData) {
      return $adjustedYOSPlanData["vesting_note"] === 1
        ? $adjustedYOSPlanData["vesting_note_text"]
        : false;
    }
    return false;
  }
);

export const maxSalaryFlag = derived(
  [generalPlanData, currentFinalAverageSalary],
  ([$generalPlanData, $currentFinalAverageSalary]) => {
    if ($currentFinalAverageSalary && $generalPlanData) {
      if (
        $currentFinalAverageSalary >= $generalPlanData["max_pensionable_salary"]
      ) {
        return true;
      }
      return false;
    }
    return false;
  }
);

export const maxReplacementFlag = derived(
  [generalPlanData, replacementRate],
  ([$generalPlanData, $replacementRate]) => {
    if ($replacementRate && $generalPlanData) {
      if ($replacementRate >= $generalPlanData["pension_max_replacement"]) {
        return true;
      }
      return false;
    }
    return false;
  }
);

//COPY RELATED
export const reportCopy = derived(
  [rawCopy, generalPlanData],
  ([$rawCopy, $generalPlanData]) => {
    if (!$rawCopy) return null;
    return formatCopy($generalPlanData);
  }
);

export function formatCopy(planData) {
  const copy = deepCopy(get(rawCopy));

  let formattedCopy = copy.map((row) => {
    if (planData) row.copy = formatDataValues(row.copy, planData);
    return row;
  });

  return formattedCopy;
}

function formatDataValues(copy, planData) {
  let foundAllValues = !copy.includes("${FROM_DATA");

  while (!foundAllValues) {
    const indexOfStart = copy.indexOf("${");
    const indexOfEnd = copy.indexOf("}");

    const insertion = copy.substring(indexOfStart + 2, indexOfEnd);
    if (!insertion.includes("FROM_DATA")) break;

    const accessor = insertion.replace("FROM_DATA_", "").replace("_BOLD", "");
    const bold = insertion.includes("_BOLD");

    let value = planData[accessor] || "--";
    if (Number.isInteger(value) && accessor === "max_pensionable_salary")
      value = formatDollars(value);
    if (bold) value = `<span class="font-bold">${value}</span>`;

    let toReplace = "${" + insertion + "}";
    copy = copy.replace(toReplace, value);

    foundAllValues = !copy.includes("${FROM_DATA");
  }

  return copy;
}

export function getCopyGroup(copy, params) {
  if (copy) {
    const filteredCopy = copy.filter((row) => {
      let filter = true;

      const columns = Object.keys(params);
      columns.forEach((column) => {
        filter = row[column] !== params[column];
      });

      return !filter;
    });

    return filteredCopy;
  }
}

export function getCopyId(copy, id) {
  if (copy) {
    const filteredCopy = copy.find((row) => row.id === id);
    if (!filteredCopy) return null;
    return filteredCopy.copy;
  }
}
